export class WrappedHttpErrorResponse extends Error {
  readonly error: any | null;

  constructor(message: string, error: any) {
    super(message);

    Object.setPrototypeOf(this, WrappedHttpErrorResponse.prototype);

    this.error = error;
  }
}